module.exports = __webpack_public_path__ + "static/media/Header-BG@2x.bd591820.jpg";